module.exports = __webpack_public_path__ + "static/media/cert_93.7ab7f5d3.jpg";